var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-input", {
    ref: "inputRef",
    staticClass: "text-right",
    attrs: {
      value: _vm.formattedValue,
      "error-message": _vm.errorMessage,
      error: !!_vm.errorMessage,
      outlined: "",
      size: "sm",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }